// Shared display formatters for timestamps and numeric values.
//
// These are the canonical implementations. Page-local copies that were
// byte-identical to these have been replaced with imports. A few pages keep
// their own variant on purpose (different null behavior or output format); those
// are documented at their call sites rather than forced through here.

/**
 * Compact relative-time string, e.g. "5s ago", "12 min ago", "3 hrs ago",
 * "2d 4h ago", "2 days ago" (when the hour remainder is 0).
 * Returns '—' for falsy input and 'just now' for a future/zero diff.
 */
export function timeAgo(iso) {
  if (!iso) return '—';
  const diffMs = Date.now() - new Date(iso).getTime();
  if (diffMs < 0) return 'just now';
  const s = Math.floor(diffMs / 1000);
  if (s < 60) return `${s}s ago`;
  const m = Math.floor(s / 60);
  if (m < 60) return `${m} min ago`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h} hr${h !== 1 ? 's' : ''} ago`;
  const d = Math.floor(h / 24);
  const rh = h % 24;
  if (rh === 0) return `${d} day${d !== 1 ? 's' : ''} ago`;
  return `${d}d ${rh}h ago`;
}

/**
 * Absolute timestamp formatted as "17 Jun, 02:30 PM" (locale-aware).
 * Returns '—' for falsy input.
 */
export function formatTs(iso) {
  if (!iso) return '—';
  return new Date(iso).toLocaleString(undefined, {
    day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit',
  });
}

/**
 * Rounds a number to at most 2 decimals; passes non-numbers through unchanged.
 */
export function fmt2(v) {
  return typeof v === 'number' ? +v.toFixed(2) : v;
}
